import { UpdateTour } from '@/api/api';
import qs from 'qs';
import { Message, Spin } from 'view-design';
import { getQuery, getStore } from '@/utils';
import i18n from '@/i18n' // 引入i8n实例

export default ({
    state: {
        Data: {}, // 获取的场景数据
        OldData: {},
        Krpano: {
            scenceList: []
        }, // 全景
        saveFlag: false, // 是否修改过
        currentMenuIndex: 2, // 当前选中的导航（0 => 保存，1 => 预览，2 => 案例， 3 => 全景，4 => 视角，5 => 热点，6 => 音乐，7 => 设计师，8 => 美化）
        openmode: -1, // 开场效果
        equityData: {} // 用户权益
    },
    mutations: {
        // 保存成功后将各个flag设置为false，从而让徽标消失
        setSaveFlag (state, data) {
            state.caseInfoFlag = data;
            state.caseMusicFlag = data;
            state.caseDesinFlag = data;
            state.caseShareFlag = data;
            state.saveFlag = data;
        },
        setMenuIndex (state, data) {
            state.currentMenuIndex = data;
        },
        setData (state, data) {
            state.Data = data;
        },
        setOldData (state, data) {
            state.OldData = data;
        },
        setDataFiled (state, { filed, data}) {
            state.Data[filed] = data;
            state.saveFlag = true;
        },
        setOpenMode (state, data) {
            state.openmode = data
        },
        setEquityData (state, data) {
            state.equityData = data
        }
    },
    getters: {
        // 如果有模块修改，就显示保存徽标
        // saveFlag: state => state.caseMusicFlag || state.caseInfoFlag || state.caseDesinFlag || state.caseShareFlag,
        saveFlag: state => state.saveFlag,
        Data: state => state.Data,
        OldData: state => state.OldData,
        currentMenuIndex: state => state.currentMenuIndex,
        openmode: state => state.openmode,
        equityData: state => state.equityData
    },
    actions: {
        handleSaveFlag ({ commit }, bloolean) {
            commit('setSaveFlag', bloolean);
        },
        setData ({ commit }, data) { // 设置总数据
            commit('setData', data);
        },
        setOldData ({ commit }, data) { // 设置总数据
            commit('setOldData', data);
        },
        handleDataFiled({ commit }, { filed, data }) { //修改Data的字段
            commit('setDataFiled', { filed, data });
        },
        handleMenuIndex ({ commit }, index) { // 切换激活导航
            commit('setMenuIndex', index);
        },
        handleUpdateTour ({ state, commit }, xml) { // 更新保存修改的数据
            return new Promise((resolve, reject) => {
                let query = {
                    tokenId: getStore({
                        name: 'access_token',
                        type: 'session'
                    }) || getQuery('tokenId'),
                    tourId: state.Data.Id, // 全景方案ID
                    name: state.Data.Name,
                    sceneId: state.Data.sceneId, // 分组ID
                    tourXml: xml,
                    sound: state.Data.Sound,
                    image: state.Data.Image,
                    description: state.Data.Description,
                    designerName: state.Data.DesignerName,
                    designerTel: state.Data.DesignerTel,
                    shareEndDate: state.Data.ShareEndDate,
                    designHeadImg: state.Data.designHeadImg,
                    brandHidden: state.Data.BrandHidden,
                };
                UpdateTour(qs.stringify(query)).then(res => {
                    if (res.IsSuccess) {
                        Message.success({ content: i18n.t('h.tipInfo.saveSuccess'), duration: 3 });
                        Spin.hide();
                        commit('setSaveFlag', false); // 取消保存徽标
                        resolve(res);
                    }
                }).catch(err => {
                    reject(err);
                });
            });
        },
        handleOpenMode({ commit }, data) {
            commit('setOpenMode', data)
        },
        handleEquityData ({ commit }, data) {
            commit('setEquityData', data)
        }
    }
});


// WEBPACK FOOTER //
// ./src/store/module/case.js